<script setup lang="ts">
import type { BaseIconName } from '@/js/account/components/base/BaseIcon.vue';
import BaseIcon from '@/js/account/components/base/BaseIcon.vue';
import { classNames } from '@/js/lib/bem';

withDefaults(
  defineProps<{
    icon: BaseIconName
    label: string
    type?: 'button' | 'submit' | 'reset'
    disabled?: boolean
    iconWidth?: number
    iconHeight?: number
  }>(),
  {
    type: 'button',
    disabled: false,
    iconWidth: 24,
    iconHeight: 24,
  },
);

const emit = defineEmits<{
  click: []
}>();

const cn = classNames('action-button');
</script>

<template>
  <button
    :type="type"
    :class="cn()"
    :disabled="disabled"
    :aria-label="label"
    @click="emit('click')"
  >
    <BaseIcon
      :name="icon"
      :class="cn('icon')"
      :width="iconWidth"
      :height="iconHeight"
    />
  </button>
</template>
